module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fnI0S"))).then(() => parcelRequire('9Lwss'));